<template>
    <vue-delayed-multiselect-ajax
        ref="multiselect"
        :key="`${_uid}-processing`"
        :custom-label="customLabel"
        :disabled="disabled"
        :name="name || 'processing_id'"
      :params="params"
      :placeholder="placeholder || $t('Select {something}', { something: $t('purchase_plans.processing') })"
      :required="required"
      :search-key="searchKey"
      :url="url"
      :value="value"
      @loaded-response="onLoadedResponse"
      v-on="$listeners"
  >
    <template v-slot:beforeList>
      <slot
          name="beforeList"
          v-bind="{ canCreate, allowedActions: effectiveAllowedActions }"
      >
        <b-button
            v-if="canCreate"
            v-b-modal="`${_uid}-processing-create-modal`"
            variant="link"
        >+
          {{ $t('Add new {something}', {something: $t('customers.types.processing')}) }}
        </b-button>
        <customer-create-modal
            v-if="canCreate"
            :id="`${_uid}-processing-create-modal`"
            :key="`${_uid}-processing-create-modal-${value}`"
            :initial-value="{ type: ['processing'] }"
            :modal-title="$t('purchase_plans.create_new_processing')"
            @created="onCreated"
        ></customer-create-modal>
      </slot>
    </template>
    <template v-slot:option="{ option }">
      <slot name="option" v-bind="{ option }"></slot>
    </template>
  </vue-delayed-multiselect-ajax>
</template>

<script>
import CustomerCreateModal from '../modals/customer-create';
import VueDelayedMultiselectAjax from "@/components/inputs/vue-delayed-multiselect-ajax.vue";

export default {
  name: 'processing-select-ajax',
  components: {
    VueDelayedMultiselectAjax,
    CustomerCreateModal,
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    value: {
      type: Number,
      default: undefined
    },
    allowedActions: {
      type: Array,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {
          sort: 'code',
        }
      }
    },
    placeholder: {
      type: String,
      default: undefined
    },
    searchKey: {
      type: String,
      default: 'filter[search]',
    },
    url: {
      type: String,
      default: '/v1/processing-customers',
    },
    customLabel: {
      type: Function,
      default({ code, name }) {
        return `${code} - ${name}`
      }
    },
    loaded: {
      type: Function,
      default() {
        return () => {
        };
      }
    }
  },
  data() {
    return {
      resolvedAllowedActions: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.multiselect && typeof this.$refs.multiselect.fetchOptions === 'function') {
        this.$refs.multiselect.fetchOptions();
      }
    });
  },
  computed: {
    effectiveAllowedActions() {
      if (Array.isArray(this.allowedActions)) {
        return this.allowedActions;
      }

      if (Array.isArray(this.resolvedAllowedActions)) {
        return this.resolvedAllowedActions;
      }

      return null;
    },
    canCreate() {
      const allowedActions = this.effectiveAllowedActions;
      if (!Array.isArray(allowedActions)) {
        return true;
      }

      return allowedActions.includes("create") || allowedActions.includes("store");
    }
  },
  methods: {
    onLoadedResponse(response) {
      this.resolvedAllowedActions = Array.isArray(response?.data?.meta?.allowed_actions)
          ? response.data.meta.allowed_actions
          : null;

      if (this.value === undefined || this.value === null || this.value === '') {
        return;
      }

      const selectedProcessing = response?.data?.data?.find((item) => String(item?.id) === String(this.value));
      if (selectedProcessing) {
        this.$emit('select', selectedProcessing)
      }
    },
    onCreated(event) {
      this.$emit('select', event)
      this.onInput(event?.id)
    },
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
